import React from 'react';
import image from '../../images/lili.png'
import { useDispatch } from 'react-redux';
import { resetModalState, setModalStage } from '../../store/modalSlice';
import Button from '../../share/button/Button';

const OgNotEligible = () => {
    const dispatch = useDispatch();
    const close = () => {
        dispatch(resetModalState());
    }
    const mintPublicly = () => {
        dispatch(setModalStage('PUBLIC_MINT'));
    }
    return (
        <div className="flex flex-col items-center gap-2">
            <img src={image} className="w-[150px] sm:w-[190px] h-auto mb-2" alt="Lili" />
            <div className="flex flex-col gap-3 items-center w-full">
                <p className="font-dang text-lg sm:text-xl md:text-[1.7rem] text-white text-center">This wallet didn't hold a legacy <br /> Lilverse NFT</p>
                <Button onClick={mintPublicly} size="cta" className="mt-2">Mint anyway</Button>
                <button onClick={close} className="font-mons text-white underline text-sm mt-1">no thanks</button>
            </div>
        </div>
    );
};

export default OgNotEligible;
